export const baseUrl = "https://api.mytrumpf.com.qa.tru"; // "https://api.mytrumpf.com";
export const useMockData = true;
